import {
  Box,
  Group,
  Select,
  SimpleGrid,
  Text,
  TextInput,
  Accordion,
  createStyles,
  Button,
  Flex,
  Divider,
  Textarea,
  rem,
} from "@mantine/core";
import React from "react";
import { useSelector } from "react-redux";
import { noteType_Client_Options } from "../../utils";
import { useMediaQuery } from "@mantine/hooks";
import { DropDownArrowSvg } from "../Svgs/DropDownArrowSvg";

const useStyles = createStyles((theme) => ({
  item: {
    border: "1px solid #E5E5E5",
    borderRadius: "16px",
    margin: "8px 0",
    overflow: "hidden",
    background: "#FCFCFC",
    ".mantine-Accordion-control": {
      backgroundColor: "#EAECF0",
      color: "#000",
    },
    ".mantine-Accordion-content": {
      padding: "0px !important",
    },
  },
  editButton: {
    backgroundColor: "transparent",
    color: "gray",
  },
  clickEditButton: {
    backgroundColor: "#000000",
    color: "#ffffff",
    border: "1px solid #000000",
    "&:hover": {
      backgroundColor: "#000000",
      color: "#ffffff",
      border: "1px solid #000000",
    },
  },
}));

const CustomRow = ({
  data,
  view,
  edit,
  functions,
  selectedField,
  isTypeEdit,
  setIsTypeEdit,
}) => {
  const { classes } = useStyles();
  const isMobileScreen = useMediaQuery("(max-width: 600px)");
  let { handleFieldsEdit, removeItem } = functions;
  const { fieldType } = useSelector((state) => state.note);
  const icon = (
      <DropDownArrowSvg color={true} style={{ width: rem(1), height: rem(1) }} />
    );

  return (
    <>
      {data?.map((element, index) => (
        <Accordion
          key={index}
          defaultValue={`field-${index}`}
          variant="separated"
          radius="md"
        >
          <Accordion.Item value={`field-${index}`} className={classes.item}>
            <Accordion.Control>
              <Group position="apart">
                <Text style={{ fontWeight: 600 }}>
                  {`${element?.field}` || "Custom Field"}
                </Text>
              </Group>
            </Accordion.Control>
            <Accordion.Panel>
              <Box className={classes.bordered}>
                <SimpleGrid
                  cols={isMobileScreen ? 1 : 2}
                  className={classes.mwd}
                  p={10}
                >
                  <TextInput
                    size="md"
                    radius={"md"}
                    label={view ? "Field Name" : null}
                    placeholder="Field Name"
                    className={classes.myfont}
                    value={element?.field}
                    onChange={(e) => {
                      handleFieldsEdit(e?.target?.value, "field", element);
                    }}
                    // disabled={view || edit}
                    disabled={view || element?._id !== selectedField}
                  />

                  <Select
                    data={fieldType?.map((val) => ({
                      value: val?.id,
                      label: val?.name?.toUpperCase(),
                    }))}
                    size="md"
                    radius={"md"}
                    label={view ? "Field Type" : null}
                    placeholder="Field Type"
                    className={classes.myfont}
                    value={element?.fieldType}
                    rightSection={icon}
                    onChange={(value) => {
                      handleFieldsEdit(value, "fieldType", element);
                    }}
                    disabled={view || element?._id !== selectedField}
                  />

                  {"options" in element &&
                    element?.options != noteType_Client_Options &&
                    element?.options != "Facilities" &&
                    element?.options != "Facility Types" &&
                    element?.options != "Staff" &&
                    element?.options !== "singleOptions" &&
                    element?.options !== "dropdownOptions" &&
                    element?.options !== "multipleOptions" && (
                      <TextInput
                      radius={"md"}
                        size="md"
                        label={view ? "Other Options" : null}
                        placeholder="Other Options"
                        className={classes.myfont}
                        value={element?.others}
                        onChange={(e) => {
                          handleFieldsEdit(e?.target?.value, "others", element);
                        }}
                        disabled={view || element?._id !== selectedField}
                      />
                    )}

                  <Select
                    data={["Yes", "No"]}
                    size="md"
                    radius={"md"}
                    rightSection={icon}
                    placeholder="Field Priority"
                    label={view ? "Priority" : null}
                    className={classes.myfont}
                    value={element?.priority ? "Yes" : "No"}
                    onChange={(value) => {
                      handleFieldsEdit(
                        value === "Yes" ? true : false,
                        "priority",
                        element
                      );
                    }}
                    disabled={view || element?._id !== selectedField}
                  />

                  <Select
                    data={["Yes", "No"]}
                    size="md"
                    radius={"md"}
                    rightSection={icon}
                    label={view ? "View Only" : null}
                    placeholder="View Only"
                    className={classes.myfont}
                    value={element?.viewOnly ? "Yes" : "No"}
                    onChange={(value) => {
                      handleFieldsEdit(
                        value === "Yes" ? true : false,
                        "viewOnly",
                        element
                      );
                    }}
                    disabled={view || element?._id !== selectedField}
                  />
                </SimpleGrid>

                {element?.multipleChoice?.length > 0 && (
                  <SimpleGrid cols={isMobileScreen ? 1 : 1} p={10}>
                    <Box>
                      {"options" in element &&
                        element?.options != noteType_Client_Options &&
                        element?.options != "Facilities" &&
                        element?.options != "Staff" && (
                          <Textarea
                            autosize
                            minRows={1}
                            maxRows={6}
                            size="md"
                            radius={"md"}
                            w={"100%"}
                            label={view ? "Multiple Options" : null}
                            placeholder="Multiple Options"
                            className={classes.myfont}
                            value={element?.multipleChoice?.join(", ")}
                            onChange={(e) => {
                              handleFieldsEdit(
                                e?.target?.value,
                                "multipleChoice",
                                element
                              );
                            }}
                            disabled={edit || view || element?._id !== selectedField }
                          />
                        )}
                    </Box>
                  </SimpleGrid>
                )}
                {element?.singleChoice?.length > 0 && (
                  <SimpleGrid cols={isMobileScreen ? 1 : 1} p={10}>
                    <Box>
                      {"options" in element &&
                        element?.options != noteType_Client_Options &&
                        element?.options != "Facilities" &&
                        element?.options != "Staff" && (
                          <Textarea
                            autosize
                            minRows={1}
                            maxRows={6}
                            radius={"md"}
                            size="md"
                            w={"100%"}
                            label={view ? "Single Option" : null}
                            placeholder="Single Option"
                            className={classes.myfont}
                            value={element?.singleChoice?.join(", ")}
                            onChange={(e) => {
                              handleFieldsEdit(
                                e?.target?.value,
                                "singleChoice",
                                element
                              );
                            }}
                            disabled={edit || view || element?._id !== selectedField }
                          />
                        )}
                    </Box>
                  </SimpleGrid>
                )}
                {element?.dropdownChoice?.length > 0 && (
                  <SimpleGrid cols={isMobileScreen ? 1 : 1} p={10}>
                    <Box>
                      {"options" in element &&
                        element?.options != noteType_Client_Options &&
                        element?.options != "Facilities" &&
                        element?.options != "Staff" && (
                          <Textarea
                            autosize
                            minRows={1}
                            maxRows={6}
                            radius={"md"}
                            size="md"
                            w={"100%"}
                            label={view ? "Dropdown Option" : null}
                            placeholder="Dropdown Option"
                            className={classes.myfont}
                            value={element?.dropdownChoice?.join(", ")}
                            onChange={(e) => {
                              handleFieldsEdit(
                                e?.target?.value,
                                "dropdownChoice",
                                element
                              );
                            }}
                            disabled={edit || view || element?._id !== selectedField }
                          />
                        )}
                    </Box>
                  </SimpleGrid>
                )}
                {!view && <Divider mt="1rem" />}
                <Flex
                  justify="flex-end"
                  align="center"
                  direction="row"
                  gap={"1rem"}
                  m={"1rem"}
                >
                  {!view && (
                    <>
                      {/* {!data && ( */}
                        <Button
                          size="sm"
                          radius="md"
                          variant="outline"
                          className={
                            element?._id === selectedField
                              ? classes.clickEditButton
                              : classes.editButton
                          }
                          onClick={() => setIsTypeEdit(element?._id)}
                        >
                          Edit
                        </Button>
                      {/* )} */}
                      <Button
                        size="sm"
                        color="red"
                        radius="md"
                        variant="filled"
                        onClick={() => removeItem(element)}
                      >
                        Delete
                      </Button>
                    </>
                  )}
                </Flex>
              </Box>
            </Accordion.Panel>
          </Accordion.Item>

          {/* Delete icon (only visible when not in view mode) */}
          {/* {!view && (
            <Box>
              <ActionIcon
                color="red"
                variant="light"
                size={44}
                mt={5}
                sx={{ padding: 10 }}
                onClick={() => removeItem(element)}
              >
                <IconTrash size={"md"} />
              </ActionIcon>
            </Box>
          )} */}
        </Accordion>
      ))}
    </>
  );
};

export default CustomRow;
